import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import useAuthActions from "../../../api/hooks/admin/auth";
import SurveyContainer from "../../atoms/layout/SurveyContainer";

const RaterLogin = () => {
  const navigate = useNavigate();
  const { raterLogin } = useAuthActions();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    //type 관리자:0 평가자:1 응시자:2
    const req = { ...data, type: 1 };
    const res = await raterLogin(req);

    if (res.status === 200) navigate(`/rater/examroom`);
  };

  // useEffect(() => navigate(0), [auth])

  return (
    <SurveyContainer title="평가자 로그인">
      <link rel="stylesheet" type="text/css" href="/css/common.css" />
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="base-sec-sec">
          <div className="login-welcome">
            <div className="login-logo"></div>
            <div className="login-welcome-text">
              <p>환영합니다. 평가시스템 사용을 위해 로그인을 해주세요.</p>
            </div>
          </div>
          <div className="login-active">
            <div className="login-id">
              <p className="login-title">아이디</p>
              <input className="login-input" type="text" {...register("id")} />
            </div>
            <div className="login-password">
              <p className="login-title">비밀번호</p>
              <input
                className="login-input"
                type="password"
                {...register("pw")}
              />
            </div>
            <div className="password-remember">
              <label className="check-container">
                <input type="checkbox" />
                <span className="checkmark"></span>
                <span>비밀번호 기억하기</span>
              </label>
            </div>
            <button className="login-act" type="submit">
              로그인
            </button>
          </div>
        </div>
        <div className="base-sec-bottom">
          <p className="guide">
            회원가입, 아이디와 비밀번호 찾기 서비스는
            <u>
              <b>에스엘아이교육그룹 사이트에서 이용</b>
            </u>
            하실수 있습니다.
          </p>
          <p className="sign_up-text">
            회원이아니신가요 ?
            <a className="sign_up" href="">
              회원가입
            </a>
          </p>
        </div>
      </form>
    </SurveyContainer>
  );
};

export default RaterLogin;
